/** Mirrors Flutter GetStorage keys: rated_${slug}, dismissed_${slug} */

/** الطلبات المكتملة / التي تم توصيلها فقط */
export function isOrderDelivered(status) {
  return String(status ?? "").toLowerCase() === "delivered";
}

/** إظهار زر/أيقونة التقييم في القوائم (بعد التوصيل، مُقيَّم أو لا) */
export function canShowOrderRatingButton(order) {
  if (!order) return false;
  return isOrderDelivered(order.status);
}

/** Normalizes API is_rated (true/false/0/1/undefined). */
function apiRatedToBool(isRated) {
  if (isRated === true || isRated === 1 || isRated === "1") return true;
  if (isRated === false || isRated === 0 || isRated === "0") return false;
  return undefined;
}

/**
 * @param {string} orderSlug
 * @param {boolean|number|string|undefined} [apiIsRated] — من الباك إن وُجد (يفضّل على localStorage)
 */
export function shouldShowRatePopup(orderSlug, apiIsRated) {
  if (!orderSlug) return false;
  const dismissed = localStorage.getItem(`dismissed_${orderSlug}`) === "1";

  const fromApi = apiRatedToBool(apiIsRated);
  if (fromApi === true) return false;
  if (fromApi === false) return !dismissed;

  const rated = localStorage.getItem(`rated_${orderSlug}`) === "1";
  return !rated && !dismissed;
}

export function markRateDismissed(orderSlug) {
  if (!orderSlug) return;
  localStorage.setItem(`dismissed_${orderSlug}`, "1");
}

export function markOrderRated(orderSlug) {
  if (!orderSlug) return;
  localStorage.setItem(`rated_${orderSlug}`, "1");
}

/**
 * @param {string} orderSlug
 * @param {boolean|number|string|undefined} [apiIsRated]
 */
export function isOrderRated(orderSlug, apiIsRated) {
  if (!orderSlug) return false;
  const fromApi = apiRatedToBool(apiIsRated);
  if (fromApi === true) return true;
  if (fromApi === false) return false;
  return localStorage.getItem(`rated_${orderSlug}`) === "1";
}
